import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteFooterComponent } from '../site-footer/site-footer.component';

@Component({
  selector: 'app-privacidad',
  imports: [RouterLink, SiteFooterComponent],
  templateUrl: './privacidad.component.html',
})
export class PrivacidadComponent {
  readonly updated = '13 de mayo de 2026';
}
